import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FiPhone, FiMapPin, FiCalendar } from "react-icons/fi";
import { GoArrowLeft } from "react-icons/go";
import { useLazyGetdepartmentQuery } from "../State/Api/GetdepartsmentsApiSlice";

function DepartmentDetails() {
  const navigate = useNavigate();
  const location=useLocation();
  const { specialization, displayName } = useParams();
  const clinicUserId = localStorage.getItem("userClinicID");

  const [fetchDepartment, { data: departmentData, isLoading , isError,isFetching }] = useLazyGetdepartmentQuery();

  useEffect(() => {
    if (specialization && clinicUserId) {
      fetchDepartment({ specialization, clinicId: clinicUserId });
    }
  }, [specialization, clinicUserId]);
 const SkeletonCard = () => (
    <div className="group relative bg-white rounded-2xl shadow-md border border-gray-100 p-4 animate-pulse">
      <div className="absolute -top-5 left-4 z-20">
        <div className="h-6 w-16 bg-gray-300 rounded-full"></div>
      </div>
      <div className="flex items-center space-x-3 mb-4 mt-4">
        <div className="w-14 h-14 rounded-2xl bg-gray-300"></div>
        <div className="flex-1 space-y-2">
          <div className="h-4 w-32 bg-gray-300 rounded"></div>
          <div className="h-3 w-20 bg-gray-200 rounded"></div>
        </div>
      </div>
      <div className="h-5 w-20 bg-gray-200 rounded mb-4"></div>
      <div className="space-y-3 text-sm">
        <div className="h-4 w-40 bg-gray-200 rounded"></div>
        <div className="h-4 w-56 bg-gray-200 rounded"></div>
        <div className="h-4 w-28 bg-gray-200 rounded"></div>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-100 flex space-x-2">
        <div className="h-10 w-full bg-gray-300 rounded-xl"></div>
        <div className="h-10 w-12 bg-gray-200 rounded-xl"></div>
      </div>
    </div>
  );

  if (isLoading || isFetching) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
        <div className="max-w-9xl mx-auto">
          {/* Header Skeleton */}
          <div className="mb-8 flex items-center gap-4 animate-pulse">
            <div className="h-10 w-10 rounded-md bg-gray-300"></div>
            <div className="space-y-2">
              <div className="h-6 w-40 bg-gray-300 rounded"></div>
              <div className="h-4 w-60 bg-gray-200 rounded"></div>
            </div>
          </div>

          {/* Grid of Skeleton Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-6">
            {[...Array(6)].map((_, i) => (
              <SkeletonCard key={i} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-red-600">Failed to load Doctor details.</p>
      </div>
    );
  }


  const doctors = departmentData || [];

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "active":
        return "bg-green-100 text-green-800 border-green-200";
      case "busy":
        return "bg-yellow-100 text-yellow-800 border-yellow-200";
      case "on leave":
        return "bg-red-100 text-red-800 border-red-200";
      default:
        return "bg-gray-100 text-gray-800 border-gray-200";
    }
  };

  const getStatusDotColor = (status) => {
    switch (status?.toLowerCase()) {
      case "active":
        return "bg-green-500";
      case "busy":
        return "bg-yellow-500";
      case "on leave":
        return "bg-red-500";
      default:
        return "bg-gray-500";
    }
  };

  const getInitialsBg = (index) => {
    const colors = [
      "linear-gradient(135deg, #667eea, #764ba2)",
      "linear-gradient(135deg, #f093fb, #f5576c)",
      "linear-gradient(135deg, #4facfe, #00f2fe)",
      "linear-gradient(135deg, #43e97b, #38f9d7)",
      "linear-gradient(135deg, #fa709a, #fee140)",
      "linear-gradient(135deg, #a8edea, #fed6e3)",
      "linear-gradient(135deg, #ffecd2, #fcb69f)",
      "linear-gradient(135deg, #ff8a80, #ff5722)",
      "linear-gradient(135deg, #ce9ffc, #7367f0)",
    ];
    return colors[index % colors.length];
  };

  const getSpecializationIcon = (specialization) => {
    switch (specialization?.toLowerCase()) {
      case "pediatrician":
        return "👶";
      case "cardiologist":
        return "❤️";
      case "neurologist":
        return "🧠";
      case "dermatologist":
        return "🩺";
      case "orthopedic surgeon":
        return "🦴";
      case "psychiatrist":
        return "🧘";
      default:
        return "👨‍⚕️";
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");
  };

  const formatPhoneNumber = (phone) => {
    const cleaned = phone?.replace(/\D/g, "");
    if (cleaned?.length === 10) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    return phone;
  };

    const query = new URLSearchParams(location.search);
  const from = query.get("from"); 

    const handleBack = () => {
    if (from) {
      navigate(from);
    } else {
   
      navigate(-1);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
      <div className="max-w-9xl mx-auto">
        <div className="mb-8 flex items-center gap-4">
          <button
            onClick={handleBack}
            className="bg-white inline-flex items-center justify-center shrink-0 gap-2 rounded-md text-sm font-medium ring-offset-background transition-colors focus:ring-2 border border-input size-10"
          >
            <GoArrowLeft />
          </button>

          <div>
            <h1 className="text-3xl font-bold text-gray-900 mb-1" style={{fontSize:'24px'}}>
              {displayName || "Department"}
            </h1>
            <p className="text-gray-600">Doctors in this department</p>
          </div>
        </div>

        {isLoading ? (
          <p className="text-center text-lg text-gray-600">Loading...</p>
        ) : doctors.length === 0 ? (
          <div className="flex flex-col items-center justify-center mt-20">
            <img
              src="/Images/doctortable.png"
              alt="No doctors available"
              className="w-64 h-64 object-contain mb-6"
            />
            <p className="text-gray-600 text-lg font-semibold">No doctors available</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-6">
            {doctors.map((doctor, index) => (
              <div
                key={doctor.doctorID}
                className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 overflow-visible mb-3"
              >
                <div className="absolute -top-5 left-4 z-20">
                  <div className="bg-white px-3 py-1 rounded-full shadow-md border border-gray-200">
                    <span className="text-xs font-semibold text-gray-700">
                      #{doctor.doctorUserUniqueID}
                    </span>
                  </div>
                </div>

                <div className="p-4 pt-6 relative flex flex-col h-full">
                  <div className="flex items-center space-x-3 mb-4">
                    <div
                      className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg relative"
                      style={{ background: getInitialsBg(index) }}
                    >
                      <span className="text-white font-bold text-xl">
                        {doctor.fullName?.charAt(0)}
                      </span>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-semibold text-gray-900 truncate text-lg">
                        {doctor.fullName}
                      </h3>
                      <p className="text-sm text-blue-600 font-medium truncate">
                        {doctor.specialization}
                      </p>
                    </div>
                  </div>

                  <div className="mb-4">
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
                        doctor.isactive
                      )}`}
                    >
                      <div
                        className={`w-1.5 h-1.5 rounded-full mr-1.5 ${getStatusDotColor(
                          doctor.isactive
                        )}`}
                      ></div>
                      {doctor.isactive}
                    </span>
                  </div>

                  <div className="space-y-3 text-sm text-gray-600 flex-grow">
                    <div className="flex items-center gap-2">
                      <FiPhone className="text-gray-600 text-[14px]" />
                      <span>{formatPhoneNumber(doctor.phoneNumber)}</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <FiMapPin className="text-gray-600 text-[13px]" />
                      <span className="line-clamp-2">{doctor.office_ClinicAddress}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <FiCalendar className="text-gray-600 text-[14px]" />
                      <span>Joined: {formatDate(doctor.joinDate)}</span>
                    </div>
                  </div>

                  <div className="mt-4 pt-4 border-t border-gray-100 flex space-x-2">
                    <button
                      onClick={() =>
                        navigate(`/DoctorProfile/${doctor?.doctorUserUniqueID}?from=${encodeURIComponent(
              location.pathname + location.search
            )}`)}
                      className="gradient-dark-button flex-1 text-white font-semibold py-2.5 rounded-xl hover:shadow-lg transform hover:scale-105 transition-all duration-200 shadow-md"
                    >
                      View Profile
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default DepartmentDetails;
